import React, {useContext, useState} from 'react';
import moment from "moment";
import __ from "lodash";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, useTheme} from '@material-ui/core';

import SystemContext from "../../../../SystemContext";
import FlightDistinctLookup from "../../../Flights/components/FlightDistinctLookup";
import FlightSelectDialogValidator from "../../validators/FlightSelectDialogValidator";
import {MaskedText} from "../../../../controls";


const FlightSelectionDialog = (props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();

  const [flight, setFlight] = useState(null);
  const [validationState, setValidationStatus] = useState({
    error: true,
    errorMessage: "checking",
    field: null
  });

  const handleClose = () => {
    setFlight(null);
    if (props.onChange)
      props.onChange(null);
  };

  const handleSave = () => {
    if (props.onChange && flight && flight.found)
      props.onChange(flight);
    else
      props.onChange(null);
    setFlight(null);
  };


  if (props.open){
    return (
      <div id={"SelectFlightDialog"}>
        <Dialog open={props.open}
                onClose={(event, reason) => {if (reason !== 'backdropClick'  && reason !== 'escapeKeyDown')  handleClose()}}
                aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            <div style={{clear: "both", backgroundColor: theme.palette.primary.main, padding:"10px"}}>
              {props.dialogTitle || "Flight Selection"}
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {props.dialogMessage || "Please select the Flight that will carry the Special Load"}<br/><br/>
            </DialogContentText>
            <Grid container checkChildren={true} spacing={1}>
              <Grid item xs={5} checkChildren={true}>
                <FlightDistinctLookup
                  label="Outbound Flight"
                  shrink
                  airportCode={props.airportCode}
                  direction={"OUT"}
                  fromDate={moment.utc(props.fromDate, "YYYY-MM-DD").format("YYYY-MM-DD")}
                  toDate={moment.utc(props.fromDate, "YYYY-MM-DD").add(14, "days").format("YYYY-MM-DD")}
                  airlineCode={flight && flight.data?flight.data.airlineCode:""}
                  flightNo={flight&& flight.data?flight.data.flightNo:""}
                  returnType="object"
                  onChange={(returnObject) => {
                    if (returnObject && __.has(returnObject, "found") && returnObject.found) {
                      setFlight(returnObject)
                    }
                    else {
                      setFlight(null)
                    }
                  }}
                />
              </Grid>
              <Grid item xs={7} checkChildren={true}>
                <MaskedText
                  label=" "
                  readOnly={true}
                  inputLabelProps={{shrink: true}}
                  fullWidth
                  value={`${flight && flight.data ? `${flight.data.originAirportCode}-${flight.data.destinationAirportCode} on ${moment.utc(flight.data.flightDate, "YYYY-MM-DD").format("DD/MMM")}`: ``}`}
                  mask={"x".repeat(50)}
                  maskChar={""}
                  forceSentenceCase={true}
                  alwaysShowMask={false}
                />
              </Grid>
            </Grid>
            <FlightSelectDialogValidator
              tripLegUuid={flight}
              onChange={(validation) => {
                setTimeout(()=> {
                  setValidationStatus(validation);
                },1);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSave} disabled={validationState.error || !flight} color="primary">
              Select
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return (<></>);
  }
}

export default FlightSelectionDialog;
